"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let RentalProperty = class RentalProperty extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    resourceId;
    onResource_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resourceId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.resourceId
            ? this.$fn.fetch('read_rental_property', { parameters: { id: this.resourceId, rental_id: this.rentalId } })
            : this.$fn.schemaDefaults('CreateRentalProperty', { valid_from: this.$fn.today() });
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['item', 'formId', 'formName', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formId: null,
                formName: "rentalProperyt",
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.resourceId ? this.$fn.gettext('Edit Rental Property') : this.$fn.gettext('Add Rental Property'),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9578_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_9584_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_9582_getActionArgs($event) {
        return {
            operation: this.item.id ? 'update_rental_property' : 'create_rental_property',
            data: { ...this.item, rental_id: this.rentalId },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_9588_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1548630417156826_request_9586_getActionArgs($event) {
        return {
            operation: "update_rental_property",
            data: {
                id: this.item.id,
                rental_id: this.rentalId,
                locked: true,
                etag: this.item.etag
            },
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_9590_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                cancel: true,
            },
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9578 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9578_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9577 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9578,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9577],
        });
        const act_2248226175642056_closeComponent_9580 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9579 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9580,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9579],
        });
        const act_1040167445267876_closeModal_9584 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_9584_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9583 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_9584,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_9582 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_9582_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_9583],
        });
        const evh_1040167445267876_submit_9581 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_9582,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9581],
        });
        const act_1548630417156826_closeModal_9588 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_9588_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_9587 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_9588,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_9586 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_9586_getActionArgs,
            displayName: "lock",
            events: [evh_1548630417156826_success_9587],
        });
        const evh_1548630417156826_clickPreventStop_9585 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_9586,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_9585],
        });
        const act_2186679009640457_closeModal_9590 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_9590_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_9589 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_9590,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_9589],
        });
        return {
            act_7315092382398562_closeModal_9578,
            evh_7315092382398562_close_9577,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9580,
            evh_2248226175642056_close_9579,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_9584,
            evh_1040167445267876_success_9583,
            act_1040167445267876_request_9582,
            evh_1040167445267876_submit_9581,
            evh_1040167445267876_submit,
            act_1548630417156826_closeModal_9588,
            evh_1548630417156826_success_9587,
            act_1548630417156826_request_9586,
            evh_1548630417156826_clickPreventStop_9585,
            evh_1548630417156826_clickPreventStop,
            act_2186679009640457_closeModal_9590,
            evh_2186679009640457_clickPreventStop_9589,
            evh_2186679009640457_clickPreventStop,
            submit: act_1040167445267876_request_9582,
            lock: act_1548630417156826_request_9586,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], RentalProperty.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalProperty.prototype, "onRental_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], RentalProperty.prototype, "resourceId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resourceId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalProperty.prototype, "onResource_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], RentalProperty.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalProperty.prototype, "onSize", null);
RentalProperty = __decorate([
    (0, vue_property_decorator_1.Component)()
], RentalProperty);
exports.default = RentalProperty;
vue_property_decorator_1.Vue.component("RentalProperty", RentalProperty);
